import React, { Component } from 'react';
import '../myutils';
import {
    DisabledInput,
    SelectInput,
    RadioButtonGroupInput,
    SimpleForm,
    translate,
    DateTimeInput,
    FormDataConsumer, required
} from 'react-admin'; 
import BookIcon from '@material-ui/icons/Book'; 
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import ContentSend from '@material-ui/icons/Send';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import { configAPI } from '../config'
import moment from 'moment';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import TextField from '@material-ui/core/TextField'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { DialogContent, Tooltip } from '@material-ui/core';

export const TemplateIcon = BookIcon;

class SendButton extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showCampaignLog: false,
            showCampaignError: false,
            CampaignAction: '',
            open: false,
            approve: false,
            approveSms: false,
            ttsContent:false,
            entriesString: '',
            campaignFileExists: false
        };
    }

    componentWillMount() {
        var requestWAV = new Request(configAPI.api.prod + '/DownloadFile?&path=' + this.props.record.id + '.wav&token=' + sessionStorage.B.encodeDecode(), {
            headers: new Headers({
              'Content-Type': 'text/json'
            }),
            method: 'GET'
          });
          fetch(requestWAV).then(data => data.text())
          .then(data => {
            if (data !== 'Requested file does not exist') {
                this.setState({campaignFileExists:true});
            }
        });

        var requestTTS = new Request(configAPI.api.prod + '/DownloadFile?&path=' + this.props.record.id + '.tts&token=' + sessionStorage.B.encodeDecode(), {
            headers: new Headers({
              'Content-Type': 'text/json'
            }),
            method: 'GET'
          });
          fetch(requestTTS).then(data => data.text())
          .then(data => {
            if (data !== 'Requested file does not exist') {
                this.setState({ ttsContent: true, ttsText: data, campaignFileExists: true })
                var requestENT = new Request(configAPI.api.prod + '/GetTemplateEntries?&templateId=' + this.props.record.id + '&token=' + sessionStorage.B.encodeDecode(), {
                    headers: new Headers({
                      'Content-Type': 'text/json'
                    }),
                    method: 'GET'
                  });
                  fetch(requestENT).then(data => data.json())
                  .then(data => {
                    if (data.responseStatus === 'OK') {
                        var entriesString = '';
                        data.entries.forEach(entry => {
                            if (entry.blocked === false) entriesString += '"'+ entry.phone + '":"'+this.state.ttsText + '",';
                        });
                        entriesString = entriesString.replace(/,\s*$/, "");
                        entriesString = "{"+ entriesString + "}";
                        this.setState({entriesString:entriesString});
                    }
                  }, (error) => {
                    if (error) {
                      this.setState({ entriesString: '' })
                    }    
                })
            }
          }, (error) => {
            this.setState({ttsContent: false});
        })
    }
    
    handleClickOpen = () => {
        this.setState({ open: true });
    };

    handleClose = () => {
        this.setState({ open: false });
    };

    handleTimeChange(e, time) {
        this.setState({
            campaignTime: moment(time).format('YYYY-MM-DD-HH:mm:ss')
        });
    }

    handleActionChange = (e) => {
        this.setState({ CampaignAction: e[0] });
    };

    handleChangeApprove = event => {
        this.setState({ approve: event.target.checked });
      };

    handleChangeApproveSMS = event => {
        this.setState({ approveSms: event[0] });
      };

    
    handleTestPhones = (e) => {
        let phones = e.target.value;
        this.setState({ phones: phones });
      };
    
    handleSendSubmit = () => {
        const { campaignTime, CampaignAction } = this.state;

        if (CampaignAction === 'T') {
            var phoneString = '';
            if (this.state.approveSms === 'S') {
                phoneString = this.state.phones + ':';
                phoneString = phoneString.replace(/:/g, '":"' + this.state.ttsText + '","').replace(/,"\s*$/, "");
                phoneString = '&ttsMode=1&withSMS=true&phones={"'+phoneString+ '}';
            }
            else phoneString = "&ttsMode=1&phones=" + this.state.phones;
            const request = new Request(configAPI.api.prod + 'RunCampaign?token=' + sessionStorage.B.encodeDecode() + '&templateId=' + this.props.record.templateId + phoneString)
            return fetch(request)
                .then(resp => { return resp.json(); })
                .then(responseRun => {
                    if (responseRun.responseStatus === 'OK') {
                        this.setState({
                            showCampaignLog: true, blocked: responseRun.blocked, pending: responseRun.pending, customerUnits: responseRun.customerUnits,
                            estimatedPrice: responseRun.estimatedPrice, entriesCount: responseRun.entriesCount
                        })
                    }
                    else this.setState({showCampaignError:true})
                })
        }        
        if (CampaignAction === 'R') {
            var data = new FormData();
            data.append("token", sessionStorage.B.encodeDecode());
            data.append("ttsMode", "1");
            data.append("templateId", this.props.record.templateId );

            if (this.state.approveSms === 'S') {
                data.append("withSMS", "true" );
                data.append("phones", this.state.entriesString);
            }

                fetch(configAPI.api.prod + 'RunCampaign', {
                    method: "POST",
                    body: data
                  })
                  .then(resp => { return resp.json(); })
                  .then(responseRun => {
                      if (responseRun.responseStatus === 'OK') {
                          this.setState({
                            showCampaignLog: true, blocked: responseRun.blocked, pending: responseRun.pending, customerUnits: responseRun.customerUnits,
                            estimatedPrice: responseRun.estimatedPrice, entriesCount: responseRun.entriesCount
                        })
                      } else {
                        this.setState({showCampaignError:true})  
                        console.log('Camapaign Failed')
                    }
                    })
                    .catch((e) => {
                    });
        }
        else if (CampaignAction === 'S') {
            const request = new Request(configAPI.api.prod + 'ScheduleCampaign?token=' + sessionStorage.B.encodeDecode() +
                '&templateId=' + this.props.record.templateId + '&time=' + campaignTime)
            return fetch(request)
                .then(resp => { return resp.json(); })
                .then(responseRun => {
                    if (responseRun.responseStatus === 'OK') {
                        this.setState({
                            showCampaignLog: true, blocked: responseRun.blocked, pending: responseRun.pending, customerUnits: responseRun.customerUnits,
                            estimatedPrice: responseRun.estimatedPrice, entriesCount: responseRun.entriesCount
                        })
                    }
                    else this.setState({showCampaignError:true})
                })
        }
    }
    render() {
        const { translate } = this.props;
        return (
            <Tooltip title={(this.state.campaignFileExists)?translate(`trans.sendCampaign`):translate(`trans.campaignError`)}>
            <div style={{ float: "right" }} onClick={(e)=>{
                e.stopPropagation();}}>
                <Button onClick={this.handleClickOpen} disabled={!this.state.campaignFileExists}>
                    <ContentSend></ContentSend>
                </Button>
                <Dialog
                    open={this.state.open}
                    onClose={this.handleClose}
                    aria-labelledby="form-dialog-title"
                >
                    <IconButton color="inherit" onClick={(e) => this.handleClose(e)} aria-label="Close" style={{ float: 'right' }}>
                        <CloseIcon />
                    </IconButton>
                    <SimpleForm
                        toolbar={false}
                        defaultValue={{ average_note: 0 }}
                    >
                        <DisabledInput source="templateId" label={translate('trans.campaignTemplate')} defaultValue={this.props.record.templateId} />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.approve}
                                    onChange={this.handleChangeApprove}
                                    value="approve"
                                />
                            }
                            label={<a target="_blank" rel="noopener noreferrer" href="https://www.call2all.co.il/ym770nir/res/terms/campaigns.html">{translate('trans.approveTerms')}</a>}
                        />
                        <SelectInput source="action" label={translate('trans.chooseAction')} choices={[
                            { id: 'TEST', name: translate('trans.testCampaign') },
                            { id: 'RUN', name: translate('trans.runCampaign') },
                            { id: 'SCHEDULE', name: translate('trans.scheduleCampaign') },
                        ]} onChange={this.handleActionChange} />
                        <FormDataConsumer>
                            {({ formData, ...rest }) => ((formData.action === "RUN") && (this.state.ttsContent)) &&
                                <Paper>
                                <div {...rest}>
                                <label>{translate('trans.choseSMSTTS')}</label>
                                <RadioButtonGroupInput source="SMS-TTS" choices={[
                                    { id: 'SMS', name: 'משולב SMS/\TTS' },
                                    { id: 'TTS', name: 'רגיל TTS' },
                                ]} onChange={this.handleChangeApproveSMS}/>
                                </div></Paper>}
                        </FormDataConsumer>
                        <FormDataConsumer>
                            {({ formData, ...rest }) => ((formData.action === "TEST") && (this.state.ttsContent)) &&
                                <Paper>
                                <div {...rest}>
                                <label>{translate('trans.choseSMSTTS')}</label>
                                <RadioButtonGroupInput source="SMS-TTS" choices={[
                                    { id: 'SMS', name: 'משולב SMS/\TTS' },
                                    { id: 'TTS', name: 'רגיל TTS' },
                                ]} onChange={this.handleChangeApproveSMS}/>
                                </div></Paper>}
                        </FormDataConsumer>
                        <FormDataConsumer>
                            {({ formData, ...rest }) => formData.action === "TEST" &&
                                <div {...rest}>
                                    <TextField
                                        id="phones"
                                        label={translate('trans.testPhones')}
                                        validate={required()} autoFocus
                                        value={this.state.folderName}
                                        onChange={this.handleTestPhones}
                                        margin="normal"
                                    />
                                </div>}
                        </FormDataConsumer>
                        <FormDataConsumer>
                            {({ formData, ...rest }) => formData.action === "SCHEDULE" &&
                                <div {...rest}>
                                    <DateTimeInput defaultValue='Time'
                                        onChange={this.handleTimeChange.bind(this)}
                                        value={this.state.campaignTime} />
                                </div>}
                        </FormDataConsumer>
                    </SimpleForm>
                    <DialogContent>
                    {(this.state.showCampaignLog)&&(<Paper>
                        <label>{translate('resources.templates.blocked')+':'+this.state.blocked}</label><br/>
                        <label>{translate('resources.templates.pending')+':'+this.state.pending}</label><br/>
                        <label>{translate('resources.templates.customer_units')+':'+this.state.customerUnits}</label><br/>
                        <label>{translate('resources.templates.estimated_price')+':'+this.state.estimatedPrice}</label><br/>
                        <label>{translate('resources.templates.entries_called')+':'+this.state.entriesCount}</label><br/>
                    </Paper>)}
                    {(this.state.showCampaignError)&&(<Paper>
                        <h1>{translate('resources.templates.campaignErrorMsg')}</h1>
                    </Paper>)}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.handleSendSubmit} color="primary" disabled={(!this.state.approve || ((this.state.ttsContent && this.state.approveSms===false) && (this.state.CampaignAction==='R' || this.state.CampaignAction==='T')))}>
                            {translate('ra.action.ok')}
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
            </Tooltip>
        );
    }
}


export default translate(SendButton);
